import { showNotification, request as sonataRequest } from 'sonata-react-components';
import { ScreenInterface } from 'sonata-static-storage/lib/schemas/screen/screen.schema';

import type { AdInterface } from 'sonata-static-storage/lib/schemas/ad/ad.schema';

type Token = Record<string, any>;

export const getBaseCurrencyByCountry = (country: string, token: Token) => {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}baseCurrency/country/${country}`,
    {
      method: 'GET'
    },
    token
  );
};

export function getUsers(token?: Token): Promise<Record<string, any>[]> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}users/allowed`,
    {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'GET'
    },
    token
  );
}

export async function getScreenSourcesPublishersDictionary(token: Token): Promise<Record<string, any>> {
  const sources = await sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}sources/screens/queryFields`,
    {
      method: 'GET',
      params: {
        queryFieldsNames: 'publisher'
      }
    },
    token
  );
  const dictionary: Record<string, any> = {};
  const screensPublisherQueryFieldData = sources?.find(({ name }: { name: string }) => name === 'publisher');
  if (screensPublisherQueryFieldData) {
    const { options } = screensPublisherQueryFieldData;
    if (options) {
      dictionary.publisher = options.reduce(
        (acc: Record<string, string>, option: { key: string; value: string }) => ({
          ...acc,
          [option.key]: option.value
        }),
        {}
      );
    }
  }
  return dictionary;
}

export async function adToValidate(
  adExchangeCode: string,
  ad: AdInterface<string>,
  lineItem: Record<string, any>,
  updateAdsAdExchangesValidation: any,
  formatMessage: any
) {
  if (ad.visible) {
    try {
      const url = `${taptap.config.sonataBackendUrl}campaign/sendToTorquemada/${lineItem._id}/behaviour/${ad._id}/adExchange/${adExchangeCode}`;

      const data = await sonataRequest.makeRequest(url, {
        data: {
          send: true
        },
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST'
      });

      updateAdsAdExchangesValidation(lineItem, [
        {
          adExchanges: data.adExchanges,
          adId: data._id
        }
      ]);

      showNotification(
        'notify',
        formatMessage({
          defaultMessage: 'Your ad has been send for approval',
          id: 'lineItems.ad.adStatus.resendAd'
        })
      );
    } catch (err: any) {
      showNotification(
        'alert',
        err && err.responseJSON && err.responseJSON.length > 0
          ? err.responseJSON[0]
          : formatMessage({
              defaultMessage: 'There was an error when trying to send the ad to validation, please try again',
              id: 'lineItems.ad.adStatus.unableToSendAdToValidate'
            })
      );
    }
  } else {
    showNotification(
      'alert',
      formatMessage({
        defaultMessage: 'The ad creative has to be visible in order to be audited',
        id: 'lineItems.ad.adStatus.creativeHasToBeVisible'
      })
    );
  }
}

export function getScreensVolumetryAndForecast({
  beginDate,
  country,
  deviceIds,
  endDate,
  sourceElementIds
}: {
  beginDate: string;
  country: string;
  deviceIds: ScreenInterface<string>['deviceId'][];
  endDate: string;
  sourceElementIds?: ScreenInterface<string>['_id'][];
}) {
  return sonataRequest.makeRequest(`${taptap.config.sonataBackendUrl}screens/forecasting`, {
    data: {
      country,
      deviceIds,
      estimated: true,
      from: beginDate,
      sourceElementIds,
      to: endDate
    },
    method: 'POST'
  });
}

export function getInventoryItems(items: string[], type: 'generic' | 'specific'): Promise<string[]> {
  return sonataRequest.makeRequest(`${taptap.config.backendUrlBase}resources/inventoryItems`, {
    data: items,
    method: 'POST',
    params: {
      type
    }
  });
}
